import { useHead } from '@unhead/vue'

export const useElfsight = () => {
	useHead({
		script: [
			{
				key: 'elfsight',
				src: 'https://static.elfsight.com/platform/platform.js',
				async: true,
			},
		],
	})
}
